import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { ClientViewStore } from "../stores/ClientViewStore"
import RootStore from "../stores/RootStore"
import { useStore } from "./useStore"

export function useReportStoreBackoffice<T extends RootStore>(): [ClientViewStore<T>, (cookieData: string) => void, (cookie?: string) => Promise<void>] {
    const { clientViewStore, login } = useStore<T>()
    const { orderId } = useParams<{ orderId: string }>()
    const [ cookieReady, setCookieReady] = useState(false);
    const [ fetchOrder, setfetchOrder] = useState(true);

    useEffect(() => {
        //TODO: remove this `if` when report is only reachable from /report/:orderId
         // eslint-disable-next-line
        if (orderId && (window as any).tfoToken) {

            // Only call fetchOrder one time or you will get 'Error: Maximum update depth exceeded.'
            if (fetchOrder) {
                setfetchOrder(false)
                clientViewStore.reportStore.fetchOrder(Number(orderId))
            }
        }
    }, [orderId, cookieReady])

    const setCookieData = (cookieData: string) => {
        const cookie = JSON.parse(cookieData);
        // eslint-disable-next-line
        (window as any).tfoToken = cookie.token;
        setCookieReady(true) // Will trigger fetchOrder in useEffect if not already run
    }

    return [clientViewStore, setCookieData, login]
}
